import React, { Component } from "react";

import {
  CCard,
  CButton,
  CCardBody,
  CBadge,
  CCardFooter,
  CLink,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CModal,
  CModalFooter,
  CModalBody,
  CModalHeader,
  CModalTitle
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import URL from "../../config/api";
import axios from "../../config/axios";
import ForumModalUpdate from "../CommunityModal/editForum";
import ForumModal from "../CommunityModal/forum";
import Loading from "../Loading";

class CommunityContentForums extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      forums: null,
      // search: "",
      // tab: 1,
      createModal: false,
      updateModal: false,
      deleteModal: false,
      updateTitle: "",
      updateDescription: "",
      updateId: null,
      deleteId: null
    };
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  componentDidMount() {
    this.updateForum();
  }

  friendlyDate(date) {
    const dt = new Date(date);
    const hj = new Date();
    const months = [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro"
    ];

    if (dt.getFullYear() !== hj.getFullYear()) {
      return `${dt.getDate()} de ${
        months[dt.getMonth()]
      } de ${dt.getFullYear()}`;
    }

    return `${dt.getDate()} de ${
      months[dt.getMonth()]
    }, às ${`00${dt.getHours()}`.slice(-2)}:${`00${dt.getMinutes()}`.slice(
      -2
    )}`;
  }

  closeCreateModal(id = null) {
    this.setState({ createModal: false });

    if (id !== null) {
      const roomId = this.props.match.params.id;
      this.props.navigate(
        `${
          (this.props.isRoom ? "/room/" : "/classroom/") + roomId
        }/forums/${id}`
      );
    }
  }

  deleteForum(id) {
    axios
      .post(`${URL.api}communication/forum/delete/${id}`, null, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.setState({ deleteModal: false });
          this.updateForum();
        },
        error => {
          this.error("Não foi possível apagar a discussão");
        }
      );
  }

  like(forum, like) {
    if (forum.user_like !== like) {
      axios
        .post(
          `${URL.api}communication/forum/like`,
          { like, user_id: this.props.user.user.id, forum_id: forum.id },
          { headers: { Authorization: `Bearer ${this.props.user.token}` } }
        )
        .then(
          resp => {
            this.updateForum();
          },
          error => {
            this.error("Não foi possível registrar a curtida");
          }
        );
    } else {
      axios
        .post(
          `${URL.api}communication/forum/like`,
          { like: null, user_id: this.props.user.user.id, forum_id: forum.id },
          { headers: { Authorization: `Bearer ${this.props.user.token}` } }
        )
        .then(
          resp => {
            this.updateForum();
          },
          error => {
            this.error("Não foi possível retirar a curtida");
          }
        );
    }
  }

  updateModel(id) {
    let updateTitle = "";
    let updateDescription = "";
    this.state.forums.forEach(forum => {
      if (forum.id === id) {
        updateTitle = forum.title;
        updateDescription = forum.description;
      }
    });

    this.setState({
      updateModal: true,
      updateId: id,
      updateTitle,
      updateDescription
    });
  }

  updateForum() {
    const { id } = this.props.match.params;

    axios
      .post(
        `${URL.api}communication/forum/list`,
        { room_id: id, user_id: this.props.user.user.id },
        { headers: { Authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(
        resp => {
          this.setState({
            forums: resp.data.data.filter(item => item.forum_id === null),
            loading: false
          });
        },
        error => {
          this.error("Não foi possível resgatar as discussões");
        }
      );
  }

  closeUpdateModal(id, title, description) {
    let forums = [];
    this.state.forums.forEach(forum => {
      if (forum.id === id) {
        forum.title = title;
        forum.description = description;
      }
      forums.push(forum);
    });

    this.setState({
      forums,
      updateModal: false,
      updateTitle: "",
      updateDescription: ""
    });
  }

  render() {
    return (
      <>
        {this.state.loading ? (
          <Loading top="45" left="50" />
        ) : (
          <React.Fragment>
            <div className="d-flex justify-content-end mb-3">
              <CButton
                color="primary"
                onClick={() => this.setState({ createModal: true })}
              >
                <i className="fa fa-plus mr-2"></i>Novo
              </CButton>
            </div>
            <ForumModal
              show={this.state.createModal}
              room={this.props.match.params.id}
              onClose={e => this.closeCreateModal(e)}
            />
            {this.state.updateModal ? (
              <ForumModalUpdate
                show={this.state.updateModal}
                id={this.state.updateId}
                room={this.props.match.params.id}
                title={this.state.updateTitle}
                description={this.state.updateDescription}
                onClose={(id, title, description) =>
                  this.closeUpdateModal(id, title, description)
                }
              />
            ) : null}

            <CModal
              show={this.state.deleteModal}
              onClose={() => this.setState({ deleteModal: false })}
              closeOnBackdrop={false}
            >
              <CModalHeader closeButton className="bg-danger">
                <CModalTitle>Apagar discussão</CModalTitle>
              </CModalHeader>
              <CModalBody>Deseja apagar a discussão selecionada?</CModalBody>
              <CModalFooter>
                <CButton
                  color="danger"
                  onClick={() => this.deleteForum(this.state.deleteId)}
                >
                  Apagar
                </CButton>{" "}
                <CButton
                  color="secondary"
                  onClick={() => this.setState({ deleteModal: false })}
                >
                  Cancelar
                </CButton>
              </CModalFooter>
            </CModal>
            {this.state.forums &&
            this.state.forums.filter(
              forum =>
                forum.title
                  .toLowerCase()
                  .includes(this.props.search.toLowerCase()) ||
                forum.description
                  .toLowerCase()
                  .includes(this.props.search.toLowerCase()) ||
                forum.user_name
                  .toLowerCase()
                  .includes(this.props.search.toLowerCase())
            ).length > 0 ? (
              <React.Fragment>
                {this.state.forums
                  .filter(
                    forum =>
                      forum.title
                        .toLowerCase()
                        .includes(this.props.search.toLowerCase()) ||
                      forum.description
                        .toLowerCase()
                        .includes(this.props.search.toLowerCase()) ||
                      forum.user_name
                        .toLowerCase()
                        .includes(this.props.search.toLowerCase())
                  )
                  .map(forum => (
                    <CCard key={forum.id}>
                      <CCardBody>
                        <div>
                          <div className="d-flex align-items-center">
                            <div className="c-avatar mr-2">
                              <img
                                className="c-avatar-img"
                                src={
                                  forum.user_photo
                                    ? URL.img + forum.user_photo
                                    : `${URL.img}uploads/users/profileEmpty.jpg`
                                }
                                alt=""
                              />
                            </div>
                            <div className="d-block w-100">
                              <div className="d-flex">
                                <span className="d-flex" style={{ flex: 1 }}>
                                  {forum.user_name}
                                </span>
                                {forum.user_id === this.props.user.user.id ||
                                this.props.general.active_roles.role_id ===
                                  6 ? (
                                  <CDropdown className="card-notice-menu">
                                    <CDropdownToggle
                                      color="white"
                                      className="card-header-action remove-caret"
                                    >
                                      <i className="fa fa-ellipsis-v"></i>
                                    </CDropdownToggle>
                                    <CDropdownMenu placement="top">
                                      <CDropdownItem
                                        onClick={() =>
                                          this.setState({
                                            deleteModal: true,
                                            deleteId: forum.id
                                          })
                                        }
                                      >
                                        Apagar
                                      </CDropdownItem>
                                      <CDropdownItem
                                        onClick={() =>
                                          this.updateModel(forum.id)
                                        }
                                      >
                                        Editar
                                      </CDropdownItem>
                                    </CDropdownMenu>
                                  </CDropdown>
                                ) : null}
                              </div>
                              <div className="text-muted">
                                {this.friendlyDate(forum.created_at)}
                              </div>
                            </div>
                          </div>
                          <h5 className="mt-3 mb-2">
                            <CLink
                              style={{ color: "inherit" }}
                              onClick={() =>
                                this.props.navigate(
                                  `${
                                    (this.props.isRoom
                                      ? "/room/"
                                      : "/classroom/") +
                                    this.props.match.params.id
                                  }/forums/${forum.id}`
                                )
                              }
                            >
                              {forum.title}
                            </CLink>
                          </h5>
                        </div>
                        <div className="text-muted">{forum.description}</div>
                      </CCardBody>
                      <CCardFooter className="d-flex justify-content-end">
                        <CBadge
                          color="light"
                          className="ml-2 p-2 cursor btn-light"
                          onClick={() =>
                            this.props.navigate(
                              `${
                                (this.props.isRoom ? "/room/" : "/classroom/") +
                                this.props.match.params.id
                              }/forums/${forum.id}#comment`
                            )
                          }
                        >
                          <i className="fa fa-comments mr-2"></i>
                          {forum.comments}
                        </CBadge>
                        <CBadge
                          color={
                            forum.user_like === true
                              ? "btn-primary"
                              : "btn-light"
                          }
                          className={`ml-2 p-2 cursor ${
                            forum.user_like === true
                              ? "btn-primary"
                              : "btn-light"
                          }`}
                          onClick={() => this.like(forum, true)}
                        >
                          <i className="fa fa-thumbs-up mr-2"></i>
                          {forum.likes}
                        </CBadge>
                        <CBadge
                          color={
                            forum.user_like === false
                              ? "btn-danger"
                              : "btn-light"
                          }
                          className={`ml-2 p-2 cursor ${
                            forum.user_like === false
                              ? "btn-danger"
                              : "btn-light"
                          }`}
                          onClick={() => this.like(forum, false)}
                        >
                          <i className="fa fa-thumbs-down mr-2"></i>
                          {forum.nlikes}
                        </CBadge>
                      </CCardFooter>
                    </CCard>
                  ))}
              </React.Fragment>
            ) : (
              <div className="d-flex align-items-center justify-content-center m-3">
                Nenhuma discussão encontrada
              </div>
            )}
          </React.Fragment>
        )}
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile,
  form: state.form
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CommunityContentForums);
